import React, { useEffect, useState } from 'react';
import { getAppEnv } from '../../../config/env';
import AutoComplete from '../CabModifySearch/CabAutoComplete';
import { getPlaceObject } from '../../utils/reverseGeoCode';
import { Stop, isInvalidMultiStopForDesktop, returnStopText } from './util';
import useOutsideClick from '../CabModifySearch/useOutsideClick';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

interface MultiCityDesktopProps {
  travelFor: string;
  setDesktopStops: (desktopStops: Stop[]) => void;
  desktopStops: Stop[];
}

const MultiCityDesktop = ({
  travelFor,
  setDesktopStops,
  desktopStops
}: MultiCityDesktopProps) => {
  const [showAutoComplete, setShowAutoComplete] = useState(false);
  const [stopIndex, setStopIndex] = useState<number | null>(null);
  const [showMulticityModal, setShowMultiCityModal] = useState(false);
  const multiCitModelref = useOutsideClick(() => {
    setShowMultiCityModal(false);
    setShowAutoComplete(false);
    const filteredStops = desktopStops?.filter(
      stop => stop?.address !== undefined && stop?.address !== null
    );
    const updatedStops = filteredStops?.map((stop, i) => ({
      ...stop,
      label: `Stop ${i + 1}`
    }));
    setDesktopStops(updatedStops);
  });
  const citySuggestRef = useOutsideClick(() => {
    setShowAutoComplete(false);
  });

  useEffect(() => {
    if (desktopStops?.length === 0) {
      setShowMultiCityModal(false);
    }
  }, [desktopStops]);

  const stopsCrud = (
    operationType: 'add' | 'update' | 'delete',
    value?: Stop,
    index?: number
  ) => {
    switch (operationType) {
      case 'add':
        setDesktopStops([
          ...desktopStops,
          {
            label: value?.label || '',
            city: value?.city || '',
            state: value?.state || '',
            placeId: value?.placeId || ''
          }
        ]);
        break;
      case 'update':
        if (index !== undefined && value) {
          const updatedStops = desktopStops?.map((stop, i) =>
            i === index ? { ...stop, ...value } : stop
          );
          setDesktopStops(updatedStops);
        }
        break;
      case 'delete':
        if (index !== undefined) {
          let filteredStops = desktopStops?.filter((_, i) => i !== index);
          filteredStops = filteredStops?.map((stop, i) => ({
            ...stop,
            label: `Stop ${i + 1}`
          }));
          setDesktopStops(filteredStops);
        }
        break;
      default:
        break;
    }
  };

  const onLocationChange = async (
    city: string,
    stn: string,
    placeId: string
  ) => {
    const placeObject = await getPlaceObject(placeId);
    closePopup();
    const newStopObject = {
      label: `Stop ${stopIndex != null ? stopIndex + 1 : ''}`,
      city: city || '',
      state: stn || '',
      placeId: placeId || '',
      address: placeObject || null
    };
    if (stopIndex !== null) {
      stopsCrud('update', newStopObject, stopIndex);
    }
  };

  const closePopup = () => {
    setShowAutoComplete(false);
  };

  const multiStopModel = () => {
    return (
      <div ref={multiCitModelref} className="multiStopModel">
        {desktopStops?.map((stop, idx) => {
          return (
            <div
              key={'stop' + idx}
              className="makeFlex spaceBetween hrtlCenter appendBottom12"
            >
              <div
                className={`msInputBox makeFlex hrtlCenter relative cursorPointer ${
                  stopIndex === idx && showAutoComplete ? 'selected' : ''
                }`}
                onClick={() => {
                  setShowAutoComplete(true);
                  setStopIndex(idx);
                }}
              >
                <div className="stopIconMake appendRight8">
                  <div className="stopLine deepskyBlueBackGroundColor">
                    <div className="stopCircle deepskyBlueBackGroundColor"></div>
                  </div>
                </div>
                <div className="stopsContainer">
                  <label className="font12 latoBold  deepskyBlueText capText cursorPointer">
                    {stop?.label}
                  </label>

                  <p className="font16 blackText latoBlack paddingT5">
                    {stop?.city}{' '}
                    <span className="greyishTxt font12 latoRegular">
                      {stop?.state}
                    </span>
                  </p>
                </div>
                {showAutoComplete && (
                  <div ref={citySuggestRef} className="mcAutoSuggest">
                    <AutoComplete
                      autoFocus={true}
                      travelFor={travelFor}
                      placeholder={'To'}
                      closeCityPopup={closePopup}
                      onChange={onLocationChange}
                      widget={0}
                    />
                  </div>
                )}
              </div>
              <div
                onClick={() => {
                  stopsCrud('delete', undefined, idx);
                }}
                className="crossIconWrapper cursorPointer"
              >
                <img
                  src={`${PUBLIC_URL}/static/public/cross_img.png`}
                  height={'24px'}
                  width={'24px'}
                  alt="crossIcon"
                />
              </div>
            </div>
          );
        })}
        {desktopStops?.length < 5 && (
          <p
            className="latoBold font14 appendTop12 deepskyBlueText cursorPointer"
            onClick={() =>
              stopsCrud('add', {
                label: `Stop ${desktopStops?.length + 1}`,
                city: '',
                state: '',
                placeId: ''
              })
            }
          >
            + ADD MORE STOPS
          </p>
        )}
      </div>
    );
  };

  return (
    <>
      <div
        className={`rsw_inputBox addBtnDesktop makeFlex perfectCenter relative`}
        onClick={() => {
          if (desktopStops?.length < 1) {
            stopsCrud('add', {
              label: `Stop ${desktopStops?.length + 1}`,
              city: '',
              state: '',
              placeId: ''
            });
          }
          setShowMultiCityModal(true);
        }}
      >
        <label
          htmlFor="addStops"
          className="lbl_input latoBold makeFlex column loaderOnClick cursorPointer marginRight5"
        >
          {desktopStops?.length > 0 &&
          !isInvalidMultiStopForDesktop(desktopStops) ? (
            <>
              <span className="appendBottom5 latoBold font12 capText deepskyBlueText">
                Stops
              </span>
              <input
                type="text"
                className={`rsw_inputField truncate font16 whiteText`}
                value={returnStopText(desktopStops)}
                readOnly
              />
            </>
          ) : (
            <span className="font13 capText deepskyBlueText">+ ADD STOPS</span>
          )}
        </label>
        <img
          src={`${PUBLIC_URL}/static/public/new_tag.png`}
          height={'17px'}
          width={'30px'}
          className="newImage"
        />
        {showMulticityModal && multiStopModel()}
      </div>
    </>
  );
};

export default MultiCityDesktop;
